module.exports = __webpack_public_path__ + "img/no-picture.d1879371.png";